import { Magic } from 'magic-sdk';
import { OpenIdExtension } from '@magic-ext/oidc';

// Create client-side Magic instance
let magic;
const createMagic = () => {
  if (magic) return magic;
  return (
    typeof window != 'undefined' &&
    new Magic(process.env.NEXT_PUBLIC_MAGIC_API_KEY, {
      extensions: [new OpenIdExtension()],
    })
  );
};

export default createMagic;
